import { useMemo } from "react";
import { FormHelperText, Typography } from "@mui/material";
import Autocomplete from "@components/Autocomplete/Autocomplete";
import { useFormattedReference } from "@hooks/useFormattedReference";
import { REFERENCE_DATA_TYPES } from "@services/referenceDataApi";
import { useTranslation } from "react-i18next";
import { usePortServicesFlow } from "../context/PortServicesFlowContext";

const LANG_BASE = "vessel-call.port-services";

interface CargoType {
  cargoTypeCode: string;
  cargoTypeDesc: string;
}

const CargoType = () => {
  const { t } = useTranslation();
  const { setCargoType, errors, setErrors } = usePortServicesFlow();
  const { options: cargoTypes } = useFormattedReference<CargoType>(
    REFERENCE_DATA_TYPES.CARGO_TYPES,
    "bff-vessel-call",
  );

  const cargoTypeOptions = useMemo(
    () =>
      Object.values(cargoTypes as unknown as Record<string, CargoType>).map((type) => ({
        label: String(type.cargoTypeDesc),
        value: String(type.cargoTypeCode),
      })),
    [cargoTypes],
  );
  return (
    <div className="flex flex-col gap-2" data-testid="port-services-cargo-type">
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {t(`${LANG_BASE}.fields.cargo-type`)}
      </Typography>
      <Autocomplete
        options={cargoTypeOptions}
        placeholder={t(`${LANG_BASE}.fields.cargo-type`)}
        onChange={(option) => {
          setCargoType(option?.value ? String(option.value) : "");
          if (errors.cargoType) {
            setErrors({ ...errors, cargoType: undefined });
          }
        }}
        testId="port-services-cargo-type"
      />
      {errors.cargoType && (
        <FormHelperText sx={{ color: "error.main", m: 0 }}>{errors.cargoType}</FormHelperText>
      )}
    </div>
  );
};

export default CargoType;
